import ShowingResults from './ShowingResults';

export default ShowingResults;
